import React from 'react';
import { Button, Form, ModalBody, ModalFooter } from 'reactstrap';
import { ModalButtonDelete, ModalButtonCancel } from '../../constant';
 
export const DeleteFormElementWS = (props) => {

    const {   methodAction,catwselement, id_elements_config, dataDatacatwselementSearch,
        handleSearchWSSElements, handleUpdateElements, saveUpdateElements, handleDeleteElements,
        saveDeleteElements, validarFormElements, handleCreateElements,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,loading,
        formValuesElements, handleInputChangeElements, handleUpdateValuesElements, handleSelectValuesElements,
        catwsprocess,validacionesElements,toggle } = props;
        //console.log(formValuesElements,"formValuesElementsDelete");
    return (
        <Form className="theme-form" role="form" onSubmit={saveDeleteElements}>
                    <ModalBody>
                        <p className="h6 txt-danger">Estas a punto de eliminar el siguiente elemento:</p>                
                        <b>{formValuesElements.nameElement}</b>
                        <br />
                        <p>¿Estás seguro de hacerlo?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button size="sm" color="primary" type="submit" className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                            {ModalButtonDelete}
                        </Button>
                        <Button size="sm" className="btn-air-light" color="light" type="button" onClick={toggle}>
                            {ModalButtonCancel}
                        </Button>
                    </ModalFooter>
                </Form>
    )
}
